export default __webpack_public_path__ + "3bd7701255b74f6de566803c81cc91db4fb33fc21073a7ef48103e059239fb94.svg";